import React from 'react';
import Print from './Print';
import { photosIn } from '../constants/galleries';

/**
 * A dated entry: the rail carries the date range, the block carries the
 * content. Both are direct children of the page grid, so the date and the
 * heading sit on the same baseline. The rail deliberately does not repeat the
 * section name — the heading is right next to it.
 *
 * Every heading is set twice, once in each language: the site language leads
 * and the other follows in small type. It runs both ways, so a Japanese reader
 * gets the same pairing an English one does.
 */
export default function Section({
  id,
  sub,
  title,
  alt,
  altJp,
  gallery,
  photoAlt,
  photoCaption,
  photoTop,
  onOpenPhotos,
  children,
}) {
  const photos = gallery ? photosIn(gallery) : [];
  return (
    <>
      <div className="rail">{sub}</div>

      <section
        className={`block${photos.length ? ' has-photo' : ''}`}
        id={id}
        aria-labelledby={`${id}-h`}
      >
        <h2 className="h" id={`${id}-h`}>
          {/* Each language is its own box, so a narrow column separates the
              two before it starts breaking either one in half. */}
          <span className="lead">{title}</span>
          {alt && <span className={`alt${altJp ? ' jp' : ''}`}>{alt}</span>}
        </h2>
        {children}

        {photos.length > 0 && (
          <Print
            /* A custom property rather than `top`: the print is only taken out
               of the flow on a wide screen, and a bare `top` on the relatively
               positioned narrow-screen print shoved it down over the next
               section. The wide-screen rule is the only thing that reads it. */
            style={photoTop ? { '--print-top': photoTop } : undefined}
            photos={photos}
            alt={photoAlt || title}
            caption={photoCaption}
            onOpen={(n) => onOpenPhotos(photos, n, photoCaption || photoAlt || title)}
          />
        )}
      </section>
    </>
  );
}
